var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","pa-0":""}},[_c('v-layout',[_c('image-slider')],1),_c('v-layout',[_c('v-flex',{staticClass:"elevation-inset-20",attrs:{"xs12":"","grey":""}},[_c('news',{staticClass:"pb-5"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }